import DecklistPreview from "../../routes/viewers/DecklistPreview";
import DecklistPreviewDraft from "../../routes/viewers/DecklistPreviewDraft";
import StandingsPreviewNew from "../../routes/viewers/StandingsPreviewNew";
import HeadToHead from "../../routes/viewers/downloader/HeadToHead";
import PlayerProfile from "../../routes/viewers/downloader/PlayerProfile";
import CustomLeaderboardPreviewWrapper from "./CustomLeaderboardPreviewWrapper";
import TeamAggregatePreview from "./TeamAggregatePreview";
import AllPlayersPreview from "./AllPlayersPreview";

export default function DownloaderPreview({ activePreview, currentPage = 0, onPreviewDataUpdate, sideboardVisible = false }) {
    return (
        <>
            {activePreview && activePreview.type === "decklist" && activePreview.param === "" &&
                <DecklistPreview
                    preview={false}
                    decklistId={activePreview.id}
                    sideboardVisible={sideboardVisible}
                />
            }

            {activePreview && activePreview.type === "decklist" && activePreview.param === "draft" &&
                <DecklistPreviewDraft
                    decklistId={activePreview.id}
                    sideboardVisible={sideboardVisible}
                />
            }
            
            {activePreview && activePreview.type === "standings" && (
                <StandingsPreviewNew
                    roundId={activePreview.id}
                    page={activePreview.param}
                />
            )}

            {activePreview && activePreview.type === "headtohead" && (
                <HeadToHead
                    headToHeadId={activePreview.id}
                    standingsId={activePreview.param}
                />
            )}

            {activePreview && activePreview.type === "playerprofile" && (
                <PlayerProfile
                    playerProfileId={activePreview.id}
                    standingsId={activePreview.param}
                />
            )}

            {activePreview && activePreview.type === "storyboard" && (
                <CustomLeaderboardPreviewWrapper
                    leaderboardId={activePreview.id}
                    params={activePreview.param}
                    currentPage={currentPage}
                    onPreviewDataUpdate={onPreviewDataUpdate}
                />
            )}

            {activePreview && activePreview.type === "team" && (
                <CustomLeaderboardPreviewWrapper
                    leaderboardId={activePreview.id}
                    params={activePreview.param}
                    currentPage={currentPage}
                    onPreviewDataUpdate={onPreviewDataUpdate}
                />
            )}

            {activePreview && activePreview.type === "teamaggregate" && (
                <TeamAggregatePreview
                    roundId={activePreview.id}
                    teamStandingsData={activePreview.param}
                    currentPage={currentPage}
                    onPreviewDataUpdate={onPreviewDataUpdate}
                />
            )}

            {activePreview && activePreview.type === "allplayers" && (
                <AllPlayersPreview
                    params={activePreview.param}
                    currentPage={currentPage}
                    onPreviewDataUpdate={onPreviewDataUpdate}
                />
            )}

        </>
    );
}